import {
  LAYOUT_IDS,
  resolvedLayoutOptions,
  studioOf,
  type LayoutOptions,
  type MobileNav,
  type StyleChoice,
  type ThemeFile,
  type ThemeMenu,
} from '@base/shared';

/** As molduras da base: uma por layout do Estúdio de estilos (ADR 0128, fases 2 e 3). */
export const SHELLS = LAYOUT_IDS;
export type Shell =
  'classic' | 'dual' | 'top' | 'split' | 'tabs' | 'launcher' | 'focus' | 'sheet' | 'inspector';

export interface ShellChoice {
  shell: Shell;
  mobileNav: MobileNav;
  /** Os ajustes do layout (as telas leem os delas: filtros, abrir um item, faixa de botões…). */
  options: LayoutOptions;
}

const isShell = (id: string): id is Shell => (SHELLS as readonly string[]).includes(id);

/**
 * A moldura que vale agora, na mesma ordem do tema (ADR 0126): com tema montado do zero no Guia
 * visual, o menu dele (lateral ou topo); senão o layout do estilo escolhido ou o de fábrica; sem
 * nenhum, o menu do tema ativo. No celular, sem escolha, o menu de sempre: a gaveta lateral.
 */
export function shellOf(
  settings: { theme: ThemeFile | null; style: StyleChoice | null } | null | undefined,
  factory: StyleChoice | null,
  activeMenu: ThemeMenu,
): ShellChoice {
  const byMenu = (menu: ThemeMenu): ShellChoice => {
    const shell = menu === 'top' ? 'top' : 'classic';
    return { shell, mobileNav: 'drawer', options: resolvedLayoutOptions(shell) };
  };
  if (settings?.theme) return byMenu(settings.theme.menu);
  const style = settings?.style ?? factory;
  const studio = style ? studioOf(style) : null;
  if (!studio || !isShell(studio.layout.id)) return byMenu(activeMenu);
  return {
    shell: studio.layout.id,
    mobileNav: studio.mobileNav ?? 'drawer',
    options: resolvedLayoutOptions(studio.layout.id, studio.layout.options),
  };
}
